const prefixKey = 'ZL_SYSTEM_'

// 使用的存储方式
export const storageType = localStorage

// 记住密码处的key
export const loginFormKey = prefixKey + 'README_INFO'
export const tokenKey = prefixKey + 'token'

// store 持久化key
export const piniaSettingStoreKey = prefixKey + 'SETTING_STORE'
export const piniaAuthStoreKey = prefixKey + 'AUTH_STORE'
export const piniaMenuStoreKey = prefixKey + 'MENU_STORE'
